import type { ProjectLifecycleCommand, ProjectLifecycleView } from "@kollectivia/shared";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";

export function useProjectLifecycle(id: string) {
  return useQuery({
    queryKey: ["projects", "lifecycle", id],
    queryFn: () => api.get<ProjectLifecycleView>(`/v1/projects/${id}/lifecycle`),
    enabled: !!id,
    refetchOnWindowFocus: "always",
  });
}
export function useProjectLifecycleCommand(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: ProjectLifecycleCommand) =>
      api.post<ProjectLifecycleView>(`/v1/projects/${id}/lifecycle`, body),
    onSuccess: () => {
      for (const key of ["projects", "quote-requests", "deadlines"])
        void qc.invalidateQueries({ queryKey: [key] });
    },
  });
}
